import WasteSegregationCreate from "../components/views/wasteSegregation/wasteSegregationCreate.vue";
import WasteSegregation from "../components/views/wasteSegregation/wasteSegregation.vue";

const routes = [
  {
    path: "wasteSegregation",
    component: WasteSegregation,
    name: "wasteSegregation",
    meta: {
      description: "List of Waste Segregation",
      title: "Waste Segregation",
      requiresAuth: true,
    },
  },
  {
    path: "wasteSegregation/wasteSegregationCreate",
    component: WasteSegregationCreate,
    name: "wasteSegregationCreate",
    meta: {
      //   description: "Add a new Segregation",
      title: "Add / Update Waste Segregation Plant",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/wastesegregation.route.js